// extracted by mini-css-extract-plugin
export default {"container_not_found":"NotFound_container_not_found__vdUD5","image_not_found":"NotFound_image_not_found__AJrvK"};